"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GetBucketReplicationInput_1 = require("./GetBucketReplicationInput");
var GetBucketReplicationOutput_1 = require("./GetBucketReplicationOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.GetBucketReplication = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "GetBucketReplication",
    http: {
        method: "GET",
        requestUri: "/{Bucket}?replication"
    },
    input: {
        shape: GetBucketReplicationInput_1.GetBucketReplicationInput
    },
    output: {
        shape: GetBucketReplicationOutput_1.GetBucketReplicationOutput
    },
    errors: []
};
//# sourceMappingURL=GetBucketReplication.js.map